import VehicleChecklist from '@/components/Qc/CheckList/Details/vehicleCheckList.vue';

export default {
  components: { VehicleChecklist },
  methods: {
    transformCheckListDetails: function (checklistDetails) {
      this.setDescriptionDetails(checklistDetails);
      this.setDrugShortageDetails(checklistDetails);
      this.setCheckListDetails(checklistDetails);
    },
    setDescriptionDetails: function (data) {
      const {
        checkListReportAttachments,
        stationShift,
        vehicle,
        isReserve,
        doctorUser,
        seniorTechnicianUser,
        secondTechnicianUser,
        last1075KM,
        fuel,
        fuelCardRemainder,
        currentKM,
        note,
        accidentNote,
        hasFuelCard,
        technicalProblem,
        boxState,
      } = data;
      const vehicleDetails = {
        title: vehicle?.vehicleType?.title,
        code: vehicle?.code,
        numberPlate: vehicle?.numberPlate || '-',
      };
      this.descriptionDetails.checkListReportAttachments = checkListReportAttachments;
      this.descriptionDetails.vehicleDetails = vehicleDetails;
      this.descriptionDetails.shift = stationShift?.title;
      this.descriptionDetails.state = isReserve ? 'رزرو' : 'آزاد';
      this.descriptionDetails.seniorTechnician =
        this.setFullNameForTechnician(seniorTechnicianUser);
      this.descriptionDetails.secondTechnicianUser =
        this.setFullNameForTechnician(secondTechnicianUser);
      this.descriptionDetails.doctor = this.setFullNameForTechnician(doctorUser);
      this.descriptionDetails.lastKM = last1075KM || '-';
      this.descriptionDetails.currentKM = currentKM || '-';
      this.descriptionDetails.fuel = fuel;
      this.descriptionDetails.fuelCardRemainder = fuelCardRemainder;
      this.descriptionDetails.lastKM = last1075KM;
      this.descriptionDetails.hasFuelCard = hasFuelCard;
      this.descriptionDetails.note = note || '-';
      this.descriptionDetails.boxState = boxState || '-';
      this.descriptionDetails.accidentNote = accidentNote || '-';
      this.descriptionDetails.technicalProblemNote = technicalProblem || '-';
    },
    setDrugShortageDetails: function (data) {
      this.descriptionDetails.checkListReportDrugShortages = [
        ...data?.checkListReportDrugShortages,
      ];
    },
    setCheckListDetails: function (data) {
      this.checkLists.tabs = [...data?.checkLists]?.map(({ id, title, checkListCategories }) => {
        return {
          id,
          title,
          details: checkListCategories,
          component: VehicleChecklist,
        };
      });
      this.checkLists.checkListCategories = [...data?.checkLists]?.map(
        ({ id, checkListCategories }) => {
          return {
            id,
            categories: [...checkListCategories],
          };
        },
      );
    },
    setFullNameForTechnician: function (technician) {
      const technicianFullName =
        technician?.firstName || technician?.lastName
          ? `${technician?.firstName} ${technician?.lastName}`
          : technician?.userName;
      return technicianFullName || 'ثبت نشده';
    },
  },
};
